import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { EntityDeletionReason } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'stateReasonDisplay',
  pure: true,
})
export class StateReasonDisplayPipe implements PipeTransform {
  transform(value: EntityDeletionReason): string {
    return CoreNiceLabelUtils.stateReason(value);
  }
}
export function stateReasonDisplayTransform(value: EntityDeletionReason | undefined): string {
  if (!value) {
    return 'Aucune raison';
  }
  return CoreNiceLabelUtils.stateReason(value);
}
